import React, { useState, useEffect } from 'react';
import Users from './components/Users';

const App = () => {
  const [users, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    setIsLoading(true);
    fetch('https://jsonplaceholder.typicode.com/users')
      .then((res) => {
        if (!res.ok) {
          throw Error('could not fetch users data');
        }
        return res.json();
      })
      .then((data) => {
        setUser(data);
        setIsLoading(false);
        setError(null);
      })
      .catch((error) => {
        setUser([]);
        setIsLoading(false);
        setError(error.message);
      });
  }, []);

  return (
    <div className="container">
      <h1 className="title">Users Management App</h1>
      {isLoading && <p>Loading users...</p>}
      {error && <p>{error}</p>}
      {users.length > 1 && <Users users={users} />}
    </div>
  );
};

export default App;
